import io from 'socket.io-client';
import { getUser } from './commonfunction';
import { ROLE } from './Constants';

const getSocketToken = () => {
    try {
        const user = getUser(ROLE.USER) || getUser();
        return user?.token || null;
    } catch (e) {
        return null;
    }
};

const CONNECTION_CONFIG = {
    "force new connection": true,
    "reconnectionAttempts": "Infinity",
    "timeout": 10000,
    "transports": ["websocket", "polling"],
    auth: (cb) => {
        cb({ token: getSocketToken() });
    }
};

const getSocketUrl = (url) => {
    if (!url) return '';
    // Strip trailing /socket.io or /socket.io/ as io() treats paths as namespaces in v4+
    return url.replace(/\/socket.io\/?$/, '');
};

export const SOCKET_CLIENT = io.connect(getSocketUrl(process.env.REACT_APP_SOCKET_URL), CONNECTION_CONFIG);

export const joinPersonalRoom = (userId, token) => {
    const userToken = token || getSocketToken();
    if (userId) {
        SOCKET_CLIENT.emit("join_personal_room", { userId: String(userId), token: userToken });
    }
};

SOCKET_CLIENT.on("connect", () => {
    console.log("✅ Socket connected:", SOCKET_CLIENT.id);
});

SOCKET_CLIENT.on("connect_error", (error) => {
    console.error("❌ Socket connection error:", error);
});

SOCKET_CLIENT.on("disconnect", (reason) => {
    console.warn("⚠️ Socket disconnected:", reason);
});

export const sendNotification = (notificationData) => {
    SOCKET_CLIENT.emit('notificationSend', notificationData, (error) => {
        /** notificationData sample 
         * 
         {
            sender_id:user._id,
            receiver_id:"650be8fe10cda2e63513231c",
            title:"New message",
            message:"Hi",
            redirection:true,
            redirect_to:"/",
            type:NOTIFICATIONS_TYPES.UNREAD_CHAT_MESSAGE
            }
         */
        if (error) {
            console.log("*****Socket connection error on notificationSend", error);
        }
    })
}